// Pagination
export const CRAWLERS_PAGE_SIZE = 25;
export const JOBS_PAGE_SIZE = 25;
export const JOB_URLS_PAGE_SIZE = 100;

// Polling intervals
export const CRAWLER_POLL_INTERVAL = 60000; // 60s
export const JOBS_POLL_INTERVAL = 30000;    // 30s
export const JOB_URLS_POLL_INTERVAL = 60000; // 60s

// Search
export const SEARCH_DEBOUNCE_MS = 300;

// Terminal job states that should stop polling
export const TERMINAL_STATES = ['done', 'failed', 'cancelled'] as const;

// Free-plan grace period cutoff date
export const FREE_PLAN_CUTOFF_DATE = "May 15, 2026";
